<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="title">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'classGroupList' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" counter="100" placeholder="Enter valid character" required v-model.trim="classObj.name" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
<label class="font-weight-medium body-2">
                  Type
                  <span class="requir error--text">*</span>
                </label>
<v-select class="my-1 py-0" placeholder="--SELECT--" v-model.trim="classObj.type" :items="typeArray" light item-text="role" item-value="type">
                  <template v-slot:selection="{ item }">
                    <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                      <span>{{ item }}</span>
                    </v-chip>
                  </template>
                </v-select>
</v-col>
<v-col cols="12" md="6">
                <v-checkbox label="is Active*" v-model="classObj.isActive"></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card></v-container
    >
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import _ from 'lodash'

export default {
  name: 'saveClassGroup',
  props: ['classGroupID'],
  components: {
    MaterialCard
  },
  data () {
    return {
      title: 'Add Class Group',
      classObj: {
        name: '',
        isActive: true,
        type: ''
      },
      typeArray: constants.CLASSGROUPTYPES,
      hasClicked: false,
      loader: false
    }
  },
  created () {
    if (this.classGroupID) {
      this.getClassGroupDetails()
    }
    this.title = this.classGroupID ? 'Edit Class Group' : 'Add Class Group'
  },
  methods: {
    save: async function () {
      this.hasClicked = true
      this.loader = true
      if (_.isEmpty(this.classObj.type)) {
        let errorMsg = 'Please select type'
        this.errMsg(errorMsg)
      } else {
        try {
          if (this.classGroupID) {
            await http.post(`${constants.API_URL}/api/student/class-group/${this.classGroupID}`, this.classObj)
            this.$router.push({ name: 'classGroupList' })
            this.okMsg('Class group Updated successfully!')
          } else {
            await http.post(`${constants.API_URL}/api/student/class-group`, this.classObj)
            this.$router.push({ name: 'classGroupList' })
            this.okMsg('Class group Saved successfully!')
          }
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(`Error While Saving Class Group: ${errorMessage}`)
        }
      }
    },
    getClassGroupDetails: async function () {
      this.hasClicked = true
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/class-group/${this.classGroupID}`, this.classObj)
        this.classObj = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Saving Class Group: ${errorMessage}`)
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
